import { IPlanLopTinChiSelectRequest } from "./../../model/request/lop-tin-chi/IPlanLopTinChiSelectRequest";

import { apiClient } from "../apiClient";
export const PLAN_LOP_TIN_CHI_ENDPOINT = "plan-lop-tin-chi";
export const planLopTinChiApi = {
  Select: (request: IPlanLopTinChiSelectRequest) =>
    apiClient.post(`${PLAN_LOP_TIN_CHI_ENDPOINT}/select-data`, request),
};
